import styled from 'styled-components';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import React, { useCallback, useEffect, useState } from 'react';
import { openDetails } from 'store/actions/uiActions';

import { BuildingTable } from 'components/Tables/BuildingTable';
import { useNavigate } from 'react-router-dom';
import { Dropdown, Loading } from '@leapeasy/ui-kit';
import { NoBuildingData } from 'components/common/NoBuildingData';
import { failedNotif } from 'store/actions/notifActions';
import { useListQueryState } from 'hooks/useListQueryState';
import { useBuildingListFetch } from 'hooks/useBuildingListFetch';
import { useImmutableJs } from 'hooks/useImmutableJs';
import { BOOLEAN_YES_NO_OPTIONS } from 'utils/formatBooleanYesNo';

export const BuildingTab = ({ building }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { filter, setFilter, sortOptions, setSortOptions, pagination, setPagination } =
    useListQueryState({
      defaultFilter: {
        options: {},
        searchText: '',
        searchPlaceholder: 'Search Property..',
      },
    });
  const [selectedBType, selSelectedBType] = useState([]);
  const [isSHouse, setIsSHouse] = useState([]);

  let buildings = useSelector((state) => state.getIn(['property', 'building']));
  const buildingsJSON = useImmutableJs(buildings);

  useBuildingListFetch({
    propertyId: building?.sf_landlord_id,
    filter,
    pagination,
    sortOptions,
    selectedBType,
    isSHouse,
    role: 'll',
    enabled: Boolean(building?.sf_landlord_id),
  });

  const onClickBuilding = useCallback(
    (building) => {
      const buildingId = building?.building_id;
      if (!buildingId) {
        dispatch(failedNotif('Property detail ID is missing.'));
        return;
      }
      navigate(`/property/properties/${buildingId}/detail/report`);
      dispatch(
        openDetails({
          type: 'property',
          data: building,
        }),
      );
    },
    [dispatch, navigate],
  );
  const resetFunc = () => {
    selSelectedBType([]);
    setIsSHouse([]);
  };
  const applyFunc = () => {};
  return (
    <Box>
      {buildings ? (
        <React.Fragment>
          <CustomBox>
            {buildingsJSON.isLoading && (
              <LoadingEffect>
                <Loading size={'large'} />
              </LoadingEffect>
            )}
            <BuildingTable
              buildings={buildingsJSON.data}
              filter={filter}
              onChangeFilter={setFilter}
              dropFilter={{
                component: (
                  <DropFilterContainer>
                    <Dropdown
                      onChange={(e) => {
                        selSelectedBType(e.target.value);
                      }}
                      options={[
                        {
                          text: 'Guarantor Waiver+LDR',
                          value: 'Event Process;Auto Enroll',
                        },
                        {
                          text: 'Rent Guaranty',
                          value: 'Auto Enroll',
                        },
                      ]}
                      value={selectedBType}
                      multiselect={true}
                      showSearch={false}
                      placeholder="Property Type"
                      label="Property Type"
                      style={{
                        width: '100%',
                      }}
                    />

                    <Dropdown
                      onChange={(e) => {
                        setIsSHouse(e.target.value);
                      }}
                      options={BOOLEAN_YES_NO_OPTIONS}
                      value={isSHouse}
                      multiselect={true}
                      showSearch={false}
                      placeholder="Student Housing"
                      label="Student Housing"
                      style={{
                        width: '100%',
                      }}
                    />
                  </DropFilterContainer>
                ),
                resetFunc: resetFunc,
                applyFunc: applyFunc,
              }}
              pagination={{
                ...pagination,
                totalItems: buildingsJSON.total,
                totalPages: Math.ceil(buildingsJSON.total / pagination.rowsPerPage),
              }}
              onChangePagination={setPagination}
              sortOptions={sortOptions}
              onChangeSort={setSortOptions}
              onClickBuilding={onClickBuilding}
            />
          </CustomBox>
          {buildingsJSON.data.length === 0 && !buildingsJSON.isLoading && <NoBuildingData />}
        </React.Fragment>
      ) : (
        <Loading size={'large'} />
      )}
    </Box>
  );
};

const DropFilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  * {
    box-sizing: border-box;
  }
`;

const CustomBox = styled.div`
  position: relative;
`;

const LoadingEffect = styled.div`
  position: absolute;
  top: 35%;
  left: 45%;
  z-index: 1;
`;
